// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__qIaxi","pagination__item":"Pagination_pagination__item__DkmOY","pagination__item_active":"Pagination_pagination__item_active__jpaIo"};